
import { defineComponent } from "vue";
import { IAcademicYearModel } from "@/interfaces/modules";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import store from "@/store";

export default defineComponent({
  name: "AcademicYearContent",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: { Id: 0 } as IAcademicYearModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Year", label: "Año", sortable: true },
          { key: "Name", label: "Nombre", sortable: true },
          { key: "StartDateFormat", label: "Inicio", sortable: true },
          { key: "EndDateFormat", label: "Fin", sortable: true },
          { key: "EnableEnrollment", label: "Permitir admisiones", sortable: true },
          { key: "IsCurrent", label: "Período actual", sortable: true },
          { key: "EnableEnrollmentEndDate", label: "Fecha límite admisiones", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IAcademicYearModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: IAcademicYearModel) =>
          [
            item.Year,
            item.Name,
            item.StartDate,
            item.EndDate,
            item.CreatedByName,
            item.ModifiedByName,
          ]
            .filter(Boolean)
            .some((v) => String(v).toLowerCase().includes(q))
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
    isEditMode(): boolean {
      return Number(this.form.record?.Id ?? 0) > 0;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await AcademicYearService.GetAcademicYears();
      this.table.loading = false;
    },
    async edit(data: IAcademicYearModel) {
      this.form.record = await AcademicYearService.GetAcademicYearById({ Id: data.Id });

      if (this.form.record.StartDate)
        this.form.record.StartDate = this.form.record.StartDate.substring(0, 10);

      if (this.form.record.EndDate)
        this.form.record.EndDate = this.form.record.EndDate.substring(0, 10);

        if (this.form.record.EnableEnrollmentEndDate)
        this.form.record.EnableEnrollmentEndDate = this.form.record.EnableEnrollmentEndDate.substring(0, 10);

      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true ,Id: 0} as IAcademicYearModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await AcademicYearService.PostAcademicYear(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
